import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class WebpageSettingService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 1226
     * @datataskName sp_ws_p2_w_webpagesetting_get
     * @param params
     * @returns promise containing the webpage setting page.
     */
    public async getWebpageSettingPage(params: GetWebpageSettingParams): Promise<WebpageSettingPageGet> {
        return (await this.datatask.Post(1226, params))[0];
    }

    /**
     * @datatask 9
     * @datataskName sp_ws_p2_webpagesettings_list
     * @param params
     * @returns promise containing list of webpage settings for the given argtype and argvalue.
     */
    public async getWebpageSettings(params: GetWebpageSettingParams): Promise<WebpageSettingItem[]> {
        return await this.datatask.Post(9, params);
    }

    /**
     * @datatask 114
     * @datataskName sp_ws_p2_webpagesettingmenu_list
     * @param params
     * @returns promise containing list of webpage settings types for the given argtype and argvalue.
     */
    public async getWebpageSettingTypes(params: GetWebpageSettingMenuParams): Promise<WebpageSettingTypeItem[]> {
        return await this.datatask.Post(114, params);
    }

    /**
     * @datatask 4025
     * @datataskName tt_webpagesettingmenu_get
     * @param params
     * @returns promise containing webpagesetting menu.
     */
    public async getWebpageSettingMenu(params: GetWebpageSettingMenuParams): Promise<WebpageSettingMenuGet> {
        return (await this.datatask.Post(4025, params))[0];
    }
}
export interface GetWebpageSettingMenuParams {
    webpage_name: string;
}

export interface GetWebpageSettingParams {
    argtype: string;
    argvalue: string;
}

export interface WebpageSettingPageGet {
    searchtext: string;
    webpage_heading: string;
}

export interface WebpageSettingItem {
    item_id: string;
    item_name: string;
    item_path: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_filtervalue: string;
}

export interface WebpageSettingTypeItem {
    item_id: string;
    item_name: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    orderby: string;
    item_state: string;
    item_parms: string;
}

export interface WebpageSettingMenuGet {
    page_heading: string;
}
